import { SvgIcon } from '@mui/material'
import {
  AlertCircle,
  AlertTriangle,
  AlignLeft,
  ArrowNarrowLeft,
  ArrowNarrowRight,
  Attachment01,
  Bell01,
  Briefcase02,
  Building05,
  Building06,
  Calendar,
  CalendarDate,
  Check,
  CheckCircle,
  CheckDone01,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  Clock,
  Columns03,
  Copy04,
  Copy07,
  CurrencyDollarCircle,
  Dotpoints01,
  Download02,
  Edit02,
  Edit03,
  Expand03,
  Eye,
  EyeOff,
  File05,
  File06,
  FileAttachment04,
  FilterFunnel02,
  Folder,
  Hash01,
  Hash02,
  Home05,
  Hourglass01,
  InfoCircle,
  LayoutAlt03,
  LinkExternal02,
  List,
  Lock01,
  Lock04,
  Plus,
  QrCode01,
  RefreshCcw01,
  RefreshCcw03,
  Save02,
  Settings01,
  SlashCircle01,
  Sliders01,
  SwitchVertical02,
  Target03,
  Trash03,
  Type01,
  Upload01,
  User03,
  Users02,
  XCircle,
  XClose,
} from '@untitled-ui/icons-react'
import {
  CirclePause,
  ClipboardClock,
  FileCheck,
  FilePenLine,
  FilePlus,
  Files,
  FileSearch,
  FileSpreadsheet,
  FileText,
  FileUp,
  FileXCorner,
  Fingerprint,
  FolderX,
  Form,
  Handshake,
  History,
  IdCardLanyard,
  Image,
  Inbox,
  Landmark,
  LetterText,
  Logs,
  Megaphone,
  NotepadText,
  Package,
  Phone,
  Play,
  Presentation,
  ReceiptText,
  ShieldCheck,
  ToggleRight,
  UserRoundCheck,
  ArrowRight,
} from 'lucide-react'

import { withTheme } from '@/hocs/with-theme'

import { BankCheck2 } from './custom/bank-check-2'
import { Calculator2 } from './custom/calculator-2'
import { CalendarDays } from './custom/calendar-days'
import { CaretDown } from './custom/caret-down'
import { CaretRight } from './custom/caret-right'
import { DragHandle } from './custom/drag-handle'
import { GripVertical } from './custom/grip-vertical'
import { GroupCol } from './custom/group-col'
import { LightBulb } from './custom/light-bulb'
import { Lock } from './custom/lock'
import { Merge } from './custom/merge'
import { MoreHorizontal } from './custom/more-horizontal'
import { PaperPlane } from './custom/paper-plane'
import { PieChart } from './custom/pie-chart'
import { Popup } from './custom/popup'
import { SearchMagnifyingGlass } from './custom/search-magnifying-glass'
import { Stars } from './custom/stars'
import { StickyNote } from './custom/sticky-note'
import { TrashFull } from './custom/trash-full'
import { TriangleWarning } from './custom/triangle-warning'
import { Upload } from './custom/upload'
import { UserAdd } from './custom/user-add'
import { UserCardId } from './custom/user-card-id'

type Props = React.ComponentProps<typeof SvgIcon>

function createSvgIcon(component: React.ElementType) {
  return withTheme((props: Props) => (
    <SvgIcon component={component} inheritViewBox {...props} style={{ fill: 'none' }} />
  ))
}

export type IconComponent = ReturnType<typeof createSvgIcon>

/**
 * Untitled UI Icons
 * https://www.untitledui.com/free-icons
 */

export const AlertCircleIcon = createSvgIcon(AlertCircle)
export const AlertTriangleIcon = createSvgIcon(AlertTriangle)
export const AlignLeftIcon = createSvgIcon(AlignLeft)
export const ArrowNarrowLeftIcon = createSvgIcon(ArrowNarrowLeft)
export const ArrowNarrowRightIcon = createSvgIcon(ArrowNarrowRight)
export const Attachment01Icon = createSvgIcon(Attachment01)
export const Bell01Icon = createSvgIcon(Bell01)
export const Briefcase02Icon = createSvgIcon(Briefcase02)
export const Building05Icon = createSvgIcon(Building05)
export const Building06Icon = createSvgIcon(Building06)
export const CalendarDateIcon = createSvgIcon(CalendarDate)
export const CheckCircleIcon = createSvgIcon(CheckCircle)
export const CheckDone01Icon = createSvgIcon(CheckDone01)
export const CheckIcon = createSvgIcon(Check)
export const CheckSquareIcon = createSvgIcon(CheckSquare)
export const ChevronDownIcon = createSvgIcon(ChevronDown)
export const ChevronLeftIcon = createSvgIcon(ChevronLeft)
export const ChevronRightIcon = createSvgIcon(ChevronRight)
export const ChevronUpIcon = createSvgIcon(ChevronUp)
export const CircleIcon = createSvgIcon(Circle)
export const ClockIcon = createSvgIcon(Clock)
export const Columns03Icon = createSvgIcon(Columns03)
export const Copy04Icon = createSvgIcon(Copy04)
export const Copy07Icon = createSvgIcon(Copy07)
export const CurrencyDollarCircleIcon = createSvgIcon(CurrencyDollarCircle)
export const Dotpoints01Icon = createSvgIcon(Dotpoints01)
export const Download02Icon = createSvgIcon(Download02)
export const Edit02Icon = createSvgIcon(Edit02)
export const Edit03Icon = createSvgIcon(Edit03)
export const Expand03Icon = createSvgIcon(Expand03)
export const EyeIcon = createSvgIcon(Eye)
export const EyeOffIcon = createSvgIcon(EyeOff)
export const File05Icon = createSvgIcon(File05)
export const File06Icon = createSvgIcon(File06)
export const FileAttachment04Icon = createSvgIcon(FileAttachment04)
export const FilterFunnel02Icon = createSvgIcon(FilterFunnel02)
export const FolderIcon = createSvgIcon(Folder)
export const Hash01Icon = createSvgIcon(Hash01)
export const Hash02Icon = createSvgIcon(Hash02)
export const Home05Icon = createSvgIcon(Home05)
export const HourglassIcon = createSvgIcon(Hourglass01)
export const InfoCircleIcon = createSvgIcon(InfoCircle)
export const LayoutAlt03Icon = createSvgIcon(LayoutAlt03)
export const LinkExternal02Icon = createSvgIcon(LinkExternal02)
export const ListIcon = createSvgIcon(List)
export const Lock01Icon = createSvgIcon(Lock01)
export const Lock04Icon = createSvgIcon(Lock04)
export const PlusIcon = createSvgIcon(Plus)
export const QrCode01Icon = createSvgIcon(QrCode01)
export const RefreshCcw01Icon = createSvgIcon(RefreshCcw01)
export const RefreshCcw03Icon = createSvgIcon(RefreshCcw03)
export const Save02Icon = createSvgIcon(Save02)
export const Settings01Icon = createSvgIcon(Settings01)
export const SlashCircle01Icon = createSvgIcon(SlashCircle01)
export const Sliders01Icon = createSvgIcon(Sliders01)
export const SwitchVertical02Icon = createSvgIcon(SwitchVertical02)
export const Target03Icon = createSvgIcon(Target03)
export const Trash03Icon = createSvgIcon(Trash03)
export const Type01Icon = createSvgIcon(Type01)
export const Upload01Icon = createSvgIcon(Upload01)
export const User03Icon = createSvgIcon(User03)
export const Users02Icon = createSvgIcon(Users02)
export const XCloseIcon = createSvgIcon(XClose)
export const XCircleIcon = createSvgIcon(XCircle)

/**
 * Lucide Icons
 * https://lucide.dev/icons
 */

export const ArrowRightIcon = createSvgIcon(ArrowRight)
export const CalendarIcon = createSvgIcon(Calendar)
export const CirclePauseIcon = createSvgIcon(CirclePause)
export const ClipboardClockIcon = createSvgIcon(ClipboardClock)
export const FileCheckIcon = createSvgIcon(FileCheck)
export const FilePenLineIcon = createSvgIcon(FilePenLine)
export const FilePlusIcon = createSvgIcon(FilePlus)
export const FileSearchIcon = createSvgIcon(FileSearch)
export const FilesIcon = createSvgIcon(Files)
export const FileSpreadsheetIcon = createSvgIcon(FileSpreadsheet)
export const FileTextIcon = createSvgIcon(FileText)
export const FileUpIcon = createSvgIcon(FileUp)
export const FileXCornerIcon = createSvgIcon(FileXCorner)
export const FingerprintIcon = createSvgIcon(Fingerprint)
export const FolderXIcon = createSvgIcon(FolderX)
export const FormIcon = createSvgIcon(Form)
export const HandshakeIcon = createSvgIcon(Handshake)
export const HistoryIcon = createSvgIcon(History)
export const IdCardLanyardIcon = createSvgIcon(IdCardLanyard)
export const ImageIcon = createSvgIcon(Image)
export const InboxIcon = createSvgIcon(Inbox)
export const LandmarkIcon = createSvgIcon(Landmark)
export const LetterTextIcon = createSvgIcon(LetterText)
export const LogsIcon = createSvgIcon(Logs)
export const MegaphoneIcon = createSvgIcon(Megaphone)
export const NotepadTextIcon = createSvgIcon(NotepadText)
export const PackageIcon = createSvgIcon(Package)
export const PhoneIcon = createSvgIcon(Phone)
export const PlayIcon = createSvgIcon(Play)
export const PresentationIcon = createSvgIcon(Presentation)
export const ReceiptTextIcon = createSvgIcon(ReceiptText)
export const ShieldCheckIcon = createSvgIcon(ShieldCheck)
export const ToggleRightIcon = createSvgIcon(ToggleRight)
export const UserRoundCheckIcon = createSvgIcon(UserRoundCheck)

/**
 * Custom Icons
 */

export const BankCheck2Icon = createSvgIcon(BankCheck2)
export const Calculator2Icon = createSvgIcon(Calculator2)
export const CalendarDaysIcon = createSvgIcon(CalendarDays)
export const CaretDownIcon = createSvgIcon(CaretDown)
export const CaretRightIcon = createSvgIcon(CaretRight)
export const DragHandleIcon = createSvgIcon(DragHandle)
export const GripVerticalIcon = createSvgIcon(GripVertical)
export const GroupColIcon = createSvgIcon(GroupCol)
export const LightBulbIcon = createSvgIcon(LightBulb)
export const LockIcon = createSvgIcon(Lock)
export const MergeIcon = createSvgIcon(Merge)
export const MoreHorizontalIcon = createSvgIcon(MoreHorizontal)
export const PaperPlaneIcon = createSvgIcon(PaperPlane)
export const PieChartIcon = createSvgIcon(PieChart)
export const PopupIcon = createSvgIcon(Popup)
export const SearchMagnifyingGlassIcon = createSvgIcon(SearchMagnifyingGlass)
export const StarsIcon = createSvgIcon(Stars)
export const StickyNoteIcon = createSvgIcon(StickyNote)
export const TrashFullIcon = createSvgIcon(TrashFull)
export const TriangleWarningIcon = createSvgIcon(TriangleWarning)
export const UploadIcon = createSvgIcon(Upload)
export const UserAddIcon = createSvgIcon(UserAdd)
export const UserCardIdIcon = createSvgIcon(UserCardId)
